// =============================================================================
// theme.js — Central design tokens (single source of truth for all colours).
//
// The app is an internal B2B tool: neutral-dominant, minimal colour, highly
// readable. Brand colour is used sparingly as a single accent; the full brand
// palette appears only in charts / data-viz.
//
// To re-theme the entire application, change the values here — nothing else.
// Brand palette: ITE (orange-red / orange / magenta / purple + warm greys).
// =============================================================================

export const colors = {
  // ── Brand ──────────────────────────────────────────────────────────────────
  brand: {
    primary:     "#E8431A", // red-orange — THE single UI accent (buttons, active nav, links, focus)
    primaryDark: "#C23417", // hover / pressed
    primaryTint: "#FCEBE5", // soft accent bg (active nav, subtle highlights)
    orange:      "#F18F18", // secondary accent + warning + chart
    magenta:     "#960659", // chart / rare emphasis
    purple:      "#5F1156", // chart / rare emphasis
  },

  // ── Text (no pure black) ─────────────────────────────────────────────────────
  text: {
    heading: "#26262A", // charcoal
    body:    "#3F3F46",
    muted:   "#818084",
    faint:   "#AFABAB",
    inverse: "#FFFFFF",
  },

  // ── Borders / dividers ───────────────────────────────────────────────────────
  border: {
    subtle: "#D8DADC",
    strong: "#AFABAB",
  },

  // ── Surfaces ─────────────────────────────────────────────────────────────────
  surface: {
    page:    "#FAFAFA",
    content: "#FFFFFF", // main content area (right of the sidebar) — flip to re-tone the whole app body
    card:    "#FFFFFF",
    subtle:  "#F4F4F5",
    hover:   "#F0F0F1",
  },

  // ── Sidebar (light, no black — a distinctly darker panel than the #F4F4F5
  //    content area so the two sections read as separate) ─────────────────────
  sidebar: {
    bg:         "#EFF0F2",
    border:     "#DADCE0",
    text:       "#3F3F46",
    muted:      "#818084",
    activeBg:   "#FCEBE5",
    activeText: "#E8431A",
    hoverBg:    "rgba(0,0,0,0.04)",
    logoFrom:   "#F18F18",
    logoTo:     "#E8431A",
  },

  // ── Status (functional; kept conventional for instant readability) ───────────
  status: {
    good:     "#15803d", goodBg: "#e9f7ef",
    warn:     "#F18F18", warnText: "#9a5b00", warnBg: "#fef4e6",
    bad:      "#C1121F", badBg: "#fdecec",
    info:     "#3F3F46", infoBg: "#F4F4F5", infoBorder: "#D8DADC", // neutralised (minimal)
  },

  // ── Categorical palette for charts / data-viz (the ONE place the full
  //    brand palette appears together). Ordered for maximum adjacent contrast. ──
  chart: ["#E8431A", "#F18F18", "#960659", "#5F1156", "#15803d", "#818084", "#C1121F", "#B23A7E"],
};

export default colors;
